import { Heading, Text } from '@cinch-labs/design-system'
import { SbBlokData } from '@cinch-nx/data-storyblok'

import styles from './accordion-section.module.css'
import { StoryblokRendererV2 as StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { servicingStoryblokComponents } from '../data/storyblok-renderer-map'

const backgroundClassNames = {
  white: styles.backgroundWhite,
  'light-2': styles.backgroundLight2,
  dark: styles.backgroundDark,
} as const

type AccordionSectionBackground = keyof typeof backgroundClassNames

export interface AccordionSectionProps {
  title?: string
  description?: string
  accordion?: SbBlokData
  cta?: SbBlokData
  background?: AccordionSectionBackground
}

export const AccordionSection = ({
  title,
  description,
  accordion,
  cta,
  background,
}: AccordionSectionProps) => {
  const backgroundClassName = background
    ? backgroundClassNames[background]
    : styles.backgroundWhite

  // On the dark background the CTA is always a primary button, restyled white
  // in the module CSS, whatever type the CMS gave it.
  const ctaBlock =
    cta && background === 'dark' ? { ...cta, type: 'primary' } : cta

  return (
    <section className={`${styles.section} ${backgroundClassName}`}>
      {(title || description) && (
        <div className={styles.content}>
          {title && (
            <Heading element="h2" className={styles.heading}>
              {title}
            </Heading>
          )}

          {description && (
            <Text className={styles.description}>{description}</Text>
          )}
        </div>
      )}

      {accordion && (
        <StoryblokRenderer
          block={accordion}
          components={servicingStoryblokComponents}
        />
      )}
      {ctaBlock && (
        <div className={styles.cta}>
          <StoryblokRenderer
            block={ctaBlock}
            components={servicingStoryblokComponents}
          />
        </div>
      )}
    </section>
  )
}

export default AccordionSection
